import { angularServicesNames } from "@topline/services/angularServicesNames";

(function (module) {
    "use strict";

    module.service('stepValidationService', [angularServicesNames.$translate, 'AlertService', function(this: $TSFixMe, $translate: ng.translate.ITranslateService, AlertService: AlertService) {
        var self = this;

        self.getSkuStepValidionError = (forecastMethodId: $TSFixMe, forecast: $TSFixMe) => {
            switch (forecastMethodId) {
                case 'sku':
                    return getSkuForecastSkuValidationError(forecast);
                case 'chamfering':
                    return getChamferingSkuValidationError(forecast);
                default:
                    return null;
            }
        }

        function getSkuForecastSkuValidationError(forecast: $TSFixMe) {
            if (!forecast || !forecast.market.brands)
                return null;

            for (const brand of forecast.market.brands) {
                for (const sku of brand.skus) {
                    if (!sku.forecast || !sku.forecast.pmForecast) {
                        var error = $translate.instant('FORECAST.SKU.VALIDATION_ERROR', { skuName: sku.name });
                        AlertService.warning(error);
                        return error;
                    }
                }
            }
            return null;
        }

        function getChamferingSkuValidationError(forecast: $TSFixMe) {
            if (!forecast || !forecast.market.brands)
                return null;

            for (const brand of forecast.market.brands) {
                for (const sku of brand.skus) {
                    if (!sku.forecast || !sku.forecast.volume.pmForecast) {
                        var error = $translate.instant('FORECAST.SKU.VALIDATION_ERROR', { skuName: sku.name });
                        AlertService.warning(error);
                        return error;
                    }
                }
            }
            return null;
        }
    }]);


})(angular.module('topline.services'));